import { Tabs } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { GetUsersDetailsById } from 'hooks'
import { useState } from 'react'
import styled from 'styled-components'
import { ArrowLeft, CaretRight, GenderFemale, GenderMale } from 'phosphor-react'
import { ViewersTable } from './viewersTableDetails'
import { CommonUtility, DateFormat, DateUtility } from 'utility'
import { LoaderBar } from 'components'
import { Images } from 'assets'
import { FollowingModal } from 'screens/creator/details/details'

const BackIcon = styled(ArrowLeft)`
  cursor: pointer;
`
const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`
const LoginDetail = styled.div`
  font-size: 14px;
  font-family: var(--font-secondary);
  font-weight: 500;
  color: #808080;

  span {
    font-weight: bold;
    color: #4c4c4c;
  }
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
`

const Breadcrumbs = styled.div`
  font-size: 14px;
`
const Link = styled.a`
  color: #84a1ff;
  text-decoration: none;
  font-weight: 500;

  span {
    color: #5c67ca;
  }
`
const Container = styled.div`
  width: 100%;
  background: #fff;
`
const ProfileContainer = styled.div`
  font-family: var(--font-secondary);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
`
const ProfileHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`
const ProfileImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
`
const ProfileInfo = styled.div`
  flex: 1;
  margin-left: 16px;
`
const CreatorName = styled.h2`
  margin: 0;
  color: #1a1a1a;
  font-weight: 600;
  font-size: 20px;
`
const LastLogin = styled.p`
  font-size: 14px;
  color: #888;
  margin: 4px 0;
`
const ProfileStats = styled.div`
  display: flex;
  gap: 30px;
`
const ProfileExtra = styled.div`
  display: flex;
  gap: 30px;
  text-align: center;
`
const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 16px;

  strong {
    font-size: 20px;
    font-family: var(--font-secondary);
    font-weight: 700;
    color: #4c4c4c;
  }

  span {
    color: #888;
    font-size: 14px;
  }
`
const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  font-size: 16px;

  strong {
    font-family: var(--font-secondary);
    font-weight: 700;
    color: #4c4c4c;
  }

  span {
    color: #888;
    font-size: 14px;
  }
`

export const ViewersDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  // const { data: creator } = GetCreatorsList(id)
  const { data: Viewers, loading } = GetUsersDetailsById(id)

  const [tab, setTab] = useState('1')
  const [isFollowingModalOpen, setFollowingModalOpen] = useState(false)
  // const onBlock = async () => {
  //   try {
  //     await UsersService.block(id, !Viewers.isBlocked)
  //   } catch (error) {
  //     console.log('error', error)
  //   }
  // }

  const displayLoginId = () => {
    if (Viewers?.signup_method === "phone") {
      return CommonUtility.formatMobileNumber(Viewers?.loginIdPhone);
    }
    if (Viewers?.signup_method === "google.com") {
      return Viewers?.loginIdEmail;
    }
    return "-";
  };

  const items = [
    {
      key: '1',
      label: 'Following',
      children: <ViewersTable />,
    },
  ]
  return (
    <>
      <Container>
        <HeaderWrapper className="p-4">
          <LeftSection>
            <BackIcon
              size={24}
              onClick={() => navigate('/app/manage-viewers')}
            />
          </LeftSection>

          <Breadcrumbs>
            <Title>Viewer Profile</Title>
            <Link href="manage-viewers">Manage Viewers</Link>
            <CaretRight size={12} color="#84a1ff" />
            <Link href="/creator/trapster-x">
              <span>{Viewers?.name}</span>
            </Link>
          </Breadcrumbs>
        </HeaderWrapper>
        {loading ? (
          <LoaderBar />
        ) : (
          <ProfileContainer className="px-5">
            <ProfileHeader>
              <ProfileImage
                src={
                  Viewers?.photo_url ||
                  (Viewers?.gender === 'female'
                    ? Images.FemaleUser
                    : Images.MaleUser)
                }
                alt={Viewers?.name}
              />

              <ProfileInfo>
                <LastLogin className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-start gap-2">
                    {Viewers?.gender === 'female' ? (
                      <GenderFemale
                        className="mt-1"
                        size={24}
                        color="#ff899e"
                      />
                    ) : (
                      <GenderMale className="mt-1" size={24} color="#24c1ff" />
                    )}
                    <div className="d-flex flex-column">
                      <div className="d-flex gap-4 align-items-center">
                        <CreatorName>{Viewers?.name}</CreatorName>
                      </div>
                      <LoginDetail>
                        {/* Last Login: <span>2 Days ago</span> {creator.lastLogin} */}
                      </LoginDetail>
                    </div>
                  </div>
                  {/* <CustomButton onClick={onBlock}>
                      {' '}
                      <Prohibit size={20} color="#e22400" /> Block Viewers
                    </CustomButton> */}
                </LastLogin>

                <div className="d-flex justify-content-between mt-2 align-items-center">
                  <ProfileStats>
                    <StatItem
                      onClick={() => setFollowingModalOpen(true)}
                      style={{ cursor: 'pointer' }}
                    >
                      <strong>{Viewers?.following_count || '0'}</strong>
                      <span>Followings</span>
                    </StatItem>
                    {/* <StatItem>
                      <strong>{Viewers?.vote_count || '0'}</strong>
                      <span>Votes</span>
                    </StatItem>
                    <StatItem>
                      <strong>{Viewers?.comment_count || '0'}</strong>
                      <span>Comments</span>
                    </StatItem> */}
                  </ProfileStats>
                  <ProfileExtra>
                    <InfoBlock>
                      <strong>
                        {displayLoginId()}
                      </strong>
                      <span>Login Id</span>
                    </InfoBlock>
                    <InfoBlock>
                      <strong>{Viewers?.birth_date}</strong>
                      <span>Birth Date</span>
                    </InfoBlock>
                    <InfoBlock>
                      <strong>
                        {DateUtility.formatDate(
                          new Date(Viewers?.createdAt),
                          DateFormat.DDMMYYYY,
                        )}
                      </strong>
                      <span>Member Since</span>
                    </InfoBlock>
                  </ProfileExtra>
                </div>
              </ProfileInfo>
            </ProfileHeader>
          </ProfileContainer>
        )}
        <FollowingModal
          open={isFollowingModalOpen}
          onClose={() => setFollowingModalOpen(false)}
          id={id}
        />
        <div className="px-5">
          <Tabs
            activeKey={tab}
            onChange={key => setTab(key)}
            items={items}
            className="custom-tabs"
            centered
          />
        </div>
      </Container>
    </>
  )
}
